import { render, staticRenderFns } from "./LinkButton.vue?vue&type=template&id=ab3cfb0c"
import script from "./LinkButton.vue?vue&type=script&lang=js"
export * from "./LinkButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports